"use client";

import { createContext, useContext, useState, ReactNode } from "react";

interface PowerModeContextType {
  isPowerModeEnabled: boolean;
  togglePowerMode: () => void;
  setPowerModeEnabled: (enabled: boolean) => void;
}

const PowerModeContext = createContext<PowerModeContextType | undefined>(undefined);

export function PowerModeProvider({ children }: { children: ReactNode }) {
  const [isPowerModeEnabled, setIsPowerModeEnabled] = useState(false);

  const togglePowerMode = () => {
    setIsPowerModeEnabled((prev) => !prev);
  };

  const setPowerModeEnabled = (enabled: boolean) => {
    setIsPowerModeEnabled(enabled);
  };

  return (
    <PowerModeContext.Provider
      value={{
        isPowerModeEnabled,
        togglePowerMode,
        setPowerModeEnabled,
      }}
    >
      {children}
    </PowerModeContext.Provider>
  );
}

export function usePowerMode() {
  const context = useContext(PowerModeContext);

  if (context === undefined) {
    throw new Error("usePowerMode must be used within a PowerModeProvider");
  }

  return context;
}
